import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  checkAuthorizationStatus,
  resetState,
  setOpLoading,
  setStatus,
} from "../features/authorizationSlice";
import { ACTION_TYPES } from "./actionTypes";
import { useEmployeesAPIs } from "../api/getEmployees";
import { BaseRequest } from "../utils/Classes/Requests/BaseRequest";
import { useNavigate } from "react-router-dom";
import { useManageEmployeeStatus } from "../api/manageEmployeeStatus";
import { fetchEmployees } from "../features/employeesSlice";
import { useExchangeApi } from "../api/ExchangeAPI";
import { fetchBranches } from "../features/branchesSlice";
import useBranchAPI from "../api/branchAPI";
import { useLegalEmployeesAPIs } from "../api/LegalEmployee";
import { fetchLegalEmployees } from "../features/legalEmployeesSlice";
import {
  setPayrollCount,
  setCheckerAdvanceId
} from "../features/AdvancePayrollConfirmPopupSlice";
import ExternalTransferAPI from "../api/ExternalTransferAPI";
import useS2SAPI from "../api/S2S_API";
import OverviewAPI from "../api/OverviewAPI";
import {
  resetResponseState,
  setFlag,
  setIsPopup,
  setLoading,
  setResponseDescription,
  setResponseTitle,
  setResponseInfo,
} from "../features/responseSlice";
import { qrTimeoutMinutes } from "../utils/Constants";
import { setQrTimeout } from "../features/authorizationSlice";
import MerchantInformationAPI from "../api/MerchantInformationAPI";
import PaymentRequestAPI from "../api/PaymentRequestAPI";
import useCardsAPI from "../api/CardsAPI";
import { toast } from "react-toastify";
import PayrollAPI from "../api/PayrollAPI";
import useLoginAPI from "../api/loginAPI";
import useQuickPayApi from "../api/QuickPayApi";
import useCashOutApi from "../api/CashOutAPI";
import useButlerApi from "../api/BulterApi";
import useAlfaApi from "../api/Bills/AlfaAPI";
import useTouchApi from "../api/Bills/TouchAPI";
import useOgeroAPI from "../api/Bills/OgeroAPI";
import useTerranetApi from "../api/Bills/TerranetAPI";
import useSodetelApi from "../api/Bills/SodetelAPI";
import useResponse from "./useResponse";
import StatementOfAccountAPI from "../api/StatementofAccountsAPI";
import useReportsApi from "../api/ReportsApi";
import useEsimApi from "../api/Bills/EsimAPI";
import {
  setQuickPayCheckerAdvanceId,
  setQuickPayList,
  setQuickPayPageActiveButton,
  setShowQuickPayDetails,
  setUploadNewBaseSalaryData,
  setNewPushQuickPayStatus,
} from "../features/QuickPaySlice";
import useCfcLoanApi from "../api/CfcLoanApi";
import useExternalCashApi from "../api/ExternalCashDepositApi";
import { setActiveButton } from "../features/ExternalCashDepositSlice";
import useBillsAPI from "../api/BillsAPI";
import usePayCorporationApi from "../api/PayCorporationApi";
import {
  resetBobCorporateState,
  setBobCorporateActiveButton,
} from "../features/BOBCorporateSlice";
import TransferAbroadAPI from "../api/TransferAbroadAPI";
import BSLAccountApi from "../api/BSLAccountApi";
import SalesTransactionsAPI from "../api/salesTransactions";
import { setButlerTabs } from "../features/CashInAndOutSlice";
import { setSelectedActionButton } from "../features/TransferCountrySelectionSlice";
import useVatApi from "../New/api/vatApi";
import useNewButlerServiceAPI from "../New/api/butlerServiceAPI";

export default function useCheckAuthorizationStatusHandler(onCloseQrReset) {
  const { DeleteEmployee, EditEmployee, AddEmployee } = useEmployeesAPIs();
  const { PushS2BTransfer, PushOutwardTransfer, SaveModificationRequestForm } =
    BSLAccountApi();
  const { ManageEmployeesStatus } = useManageEmployeeStatus();
  const {
    ManageLegalEmployeesStatus,
    EditLegalEntityEmployee,
    DeleteLegalEntityEmployee,
    AddLegalEntityEmployee,
    EditEmployeeLimitation,
    InsertProfile,
  } = useLegalEmployeesAPIs();

  const { GetAvailableSalesAndBalance } = SalesTransactionsAPI();
  const { saveCorporateTvaData } = useVatApi();

  const { updateExchangeRate } = useExchangeApi();
  const { AddBranch, EditBranch, UpdateBranchVisibility } = useBranchAPI();
  const { NewBankDepositRequest } = ExternalTransferAPI();
  const { PushS2STransfer, PushBulkS2STransfer } = useS2SAPI();
  const { InitiateExchange } = useExchangeApi();
  const {
    ConfirmTransferToLegal,
    ApproveRejectAwaitingTrx,
    ApproveListAwaitingTrx,
  } = OverviewAPI();
  const { ManageAutoExchange } = MerchantInformationAPI();
  const { EditMerchantInfo } = MerchantInformationAPI();
  const {
    InitiatePaymentRequest,
    InitiateBulkPaymentRequest,
    ReversePayment,
    CancelRequestToPay,
    GetPaymentRequest,
  } = PaymentRequestAPI();
  const {
    RequestCorporateCard,
    EditCorporateCard,
    ActivateDeactivateCorporateCard,
    CancelCorporateCard,
  } = useCardsAPI();
  const {
    PaySinglePayroll,
    DeletePayroll,
    DeletePayrollMobile,
    SubmitPayrollTemplate,
    ConfirmPayrollTemplate,
    RejectPayroll,
    RejectPayrollMobile,
    ApprovePayroll,
    ApprovePayrollMobile,
    ExportPayrollReceipts,
    CancelPayrollTemplate,
    ActionEmployeesOverview,
  } = PayrollAPI();
  // const { UploadPayrollAdvanceList, ReplacePayrollAdvanceList, EditUserPayrollAdvance, GetCashAdvanceDesign, ConfirmEligibleEmployees, DeleteUserPayrollAdvance, ToStatusUserPayrollAdvance, PushPayrollAdvanceList, ApproveRejectPayrollAdvance } = usePayrollAdvanceApi();
  const { checkQrAxios } = useLoginAPI();
  const { NewCashoutOrder, NewCashDepositRequest } = useCashOutApi();
  const { NewButlerRequest } = useNewButlerServiceAPI();
  const { PayAlfaBill, BuyAlfaCard } = useAlfaApi();
  const { PayTouchBill, BuyTouchCard } = useTouchApi();
  const { PayOgeroBill } = useOgeroAPI();
  const { PayTerranetBill } = useTerranetApi();
  const { sodetelRefill } = useSodetelApi();
  const { DownloadCorporateSoa } = StatementOfAccountAPI();
  const { newReport, deleteReport, resendReport, updateReport } =
    useReportsApi();
  const { PurchaseTopupEsim } = useEsimApi();
  const {
    UploadQuickPay,
    PushQuickPay,
    deletePendingApprovalQuickPay,
    DeleteSingleUserQuickPay,
    EditSingleUserQuickPay,
    CreateQuickPayRequest,
    UploadNewQuickPayEmployees,
    PushNewQuickPayEmployees,
    ApproveRejectQuickPay,
    ApproveRejectQuickPayMobile,
    GetQuickPayDesign,
    deleteApprovalQuickPay,
    GetQuickPayList,
    GetQuickPayDetails,
  } = useQuickPayApi();
  const { GetAccountBalance } = OverviewAPI();

  const { UpdateAutomaticBillPayment } = useBillsAPI();

  const { ExecuteInternationalTransfer } = TransferAbroadAPI();

  const { UpdateEmployeeLoanEligibility, GetEmployeeLoanEligiblity } =
    useCfcLoanApi();

  const { GenerateCashDepositCode } = useExternalCashApi();

  const { ExecuteCompanyTransfer } = usePayCorporationApi();

  const controller = new AbortController();
  const timer = useRef(0);
  const {
    authorizationCode,
    status,
    qrTimeout,
    error,
    actionType,
    actionPayload,
  } = useSelector((state) => state.authorization);
  const pageDetails = useSelector(
    (state) => state?.quickPay?.selectedQuickPayDetails,
  );
  const selectedPage = useSelector(
    (state) => state.paymentRequest.selectedPage,
  );
  const { payrollPageActiveButton } = useSelector(
    (state) => state.advancePayrollConfirm,
  );

  const dispatch = useDispatch();
  const _isMounted = useRef(false);
  const navigate = useNavigate();
  const { successResponse, errorResponse } = useResponse();

  useEffect(() => {
    if (!_isMounted.current) {
      _isMounted.current = true;
      return;
    }
    let countDownDate = new Date();
    countDownDate.setMinutes(countDownDate.getMinutes() + qrTimeoutMinutes);
    countDownDate = countDownDate.getTime();

    if (!qrTimeout && authorizationCode && authorizationCode.length > 0) {
      timer.current = setInterval(() => {
        let now = new Date().getTime();
        let distance = countDownDate - now;

        if (
          distance < 0 ||
          (!authorizationCode && authorizationCode.length === 0)
        ) {
          clearInterval(timer.current);
          dispatch(setQrTimeout(true));
          return;
        }
        dispatch(
          checkAuthorizationStatus({ authCode: authorizationCode, controller }),
        );
      }, 2000);
    } else {
      controller.abort();
      clearInterval(timer.current);
    }
  }, [authorizationCode]);

  const errorCaseInSuccessResponse = (res) => {
    if (res?.flagCode === 2) {
      dispatch(setLoading("idle"));
      dispatch(setIsPopup(true));
      dispatch(setFlag(res?.flagCode || 10));
      dispatch(setResponseTitle(res.Title));
      dispatch(setResponseDescription(res.Message));
    }
  };

  useEffect(() => {
    const check = async (actionType, payload) => {
      let data;
      switch (actionType) {
        case ACTION_TYPES.CHANGE_RATES:
          data = await updateExchangeRate(payload);
          if (data) {
            toast.success(data.message || data.title);
          }
          break;

        case ACTION_TYPES.EDIT_EMPLOYEE:
          data = await EditEmployee(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchEmployees());
              dispatch(fetchBranches());
            });
          break;
        case ACTION_TYPES.DELETE_EMPLOYEE:
          data = await DeleteEmployee(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchEmployees());
              dispatch(fetchLegalEmployees());
              dispatch(fetchBranches());
            });

          break;
        case ACTION_TYPES.ADD_EMPLOYEE || ACTION_TYPES.MIGRATE_EMPLOYEE:
          data = await AddEmployee(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchEmployees());
            });
          break;
        case ACTION_TYPES.BLOCK_EMPLOYEE:
          data = await ManageEmployeesStatus(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchEmployees());
              dispatch(fetchLegalEmployees());
            });

          break;

        case ACTION_TYPES.ADD_LEGAL_EMPLOYEE:
          data = AddLegalEntityEmployee(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchLegalEmployees());
            });
          break;
        case ACTION_TYPES.SAVE_MODIFICATION_REQUEST:
          data = SaveModificationRequestForm(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchLegalEmployees());
            });
          break;
        case ACTION_TYPES.BLOCK_LEGAL_EMPLOYEE:
          data = await ManageLegalEmployeesStatus(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchLegalEmployees());
            });
          break;
        // case ACTION_TYPES.TO_STATUS_USER_PAYROLL_ADVANCE:
        //     data = await ToStatusUserPayrollAdvance(payload)
        //         .then((res) => {
        //             successResponse(res.Payload);
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         }).finally(() => dispatch(setPayrollPageActiveButton({ name: "Quick Pay" })));
        //     break;
        // case ACTION_TYPES.DELETE_USER_PAYROLL_ADVANCE:
        //     dispatch(setLoading("pending"));
        //     data = await DeleteUserPayrollAdvance(payload)
        //         .then((res) => {
        //             successResponse(res.Payload);
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         }).finally(() => dispatch(setPayrollPageActiveButton({ name: "Quick Pay" })));
        //     break;
        case ACTION_TYPES.EDIT_LEGAL_EMPLOYEE:
          data = await EditLegalEntityEmployee(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchLegalEmployees());
            });
          break;
        case ACTION_TYPES.DELETE_LEGAL_EMPLOYEE:
          data = await DeleteLegalEntityEmployee(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(fetchLegalEmployees());
            });
          dispatch(setStatus("COMPLETE"));
          break;

        case ACTION_TYPES.ADD_BRANCH:
          data = await AddBranch(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setStatus("COMPLETE"));
              dispatch(fetchBranches());
            })
            .catch((error) => {
              errorResponse(error);
            });

          break;

        case ACTION_TYPES.GENERATE_CASH_DEPOSIT_CODE:
          dispatch(setLoading("pending"));
          data = await GenerateCashDepositCode(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
              dispatch(setActiveButton({ name: "External Cash Deposit" }));
            })
            .finally(() => dispatch(setLoading("idle")));

          break;
        case ACTION_TYPES.EDIT_BRANCH:
          data = await EditBranch(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setStatus("COMPLETE"));
              dispatch(fetchBranches());
              navigate("/branches");
            })
            .catch((error) => {
              errorResponse(error);
            });

          break;

        // case ACTION_TYPES.DELETE_BRANCH:
        //     data = await DeleteBranch(payload);
        //     navigate("/homepage/branches");
        //     dispatch(fetchBranches());
        //     break;
        case ACTION_TYPES.HIDE_BRANCH:
          data = await UpdateBranchVisibility(payload)
            .then((res) => {
              successResponse(res);
              dispatch(fetchBranches());
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;

        case ACTION_TYPES.PUSH_BANK_TRANSFER:
          dispatch(setLoading("pending"));
          data = NewBankDepositRequest(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          if (!data) dispatch(resetResponseState());
          break;

        case ACTION_TYPES.PUSH_OUTWARD_TRANSFER:
          dispatch(setLoading("pending"));
          data = PushOutwardTransfer(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          if (!data) dispatch(resetResponseState());
          break;

        // case ACTION_TYPES.PUSH_BULK_BANK_TRANSFER:
        //     dispatch(setLoading("pending"));
        //     data = PushBulkBankTransfer(payload).then((res) => {
        //         successResponse(res);
        //     }).catch((error) => {
        //         errorResponse(error);
        //     });
        //     if (!data) dispatch(resetResponseState());
        //     break;

        case ACTION_TYPES.PUSH_S2S_TRANSFER:
          dispatch(setLoading("pending"));

          data = PushS2STransfer(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          if (!data) dispatch(resetResponseState());
          break;

        case ACTION_TYPES.PUSH_S2B_TRANSFER:
          dispatch(setLoading("pending"));

          data = PushS2BTransfer(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          if (!data) dispatch(resetResponseState());
          break;

        case ACTION_TYPES.PUSH_BULK_S2S_TRANSFER:
          dispatch(setLoading("pending"));

          data = PushBulkS2STransfer(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          if (!data) dispatch(resetResponseState());
          break;

        case ACTION_TYPES.INITIATE_EXCHANGE:
          dispatch(setLoading("pending"));
          data = InitiateExchange(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          if (!data) dispatch(resetResponseState());
          break;

        case ACTION_TYPES.CONFIRM_INITIATE_TRANSFER:
          data = ConfirmTransferToLegal(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            });

          break;
        case ACTION_TYPES.APPROVE_TRX:
          dispatch(setLoading("pending"));
          data = ApproveRejectAwaitingTrx(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(setStatus("Complete"));
              dispatch(setLoading("idle"));
            });
          break;
        case ACTION_TYPES.APPROVE_LIST_TRX:
          dispatch(setLoading("pending"));
          data = ApproveListAwaitingTrx(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setStatus("Complete"));
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.MANAGE_AUTO_CONVERSION:
          data = ManageAutoExchange(payload)
            .then((res) => {
              dispatch(setResponseInfo({ checked: res.data.Payload.IsOn }));
              dispatch(setFlag(0));
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.EDIT_MERCHANT_INFO:
          dispatch(setLoading("pending"));
          data = await EditMerchantInfo(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setLoading("idle"));
              checkQrAxios();
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.EDIT_EMPLOYEE_LIMITATION:
          dispatch(setLoading("pending"));
          data = await EditEmployeeLimitation(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setLoading("idle"));
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.INITIATE_PAYMENT_REQUEST:
          dispatch(setLoading("pending"));
          data = await InitiatePaymentRequest(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setLoading("idle"));
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.INITIATE_BULK_PAYMENT_REQUEST:
          dispatch(setLoading("pending"));
          data = await InitiateBulkPaymentRequest(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.REVERSE_TRANSACTION:
          dispatch(setLoading("pending"));
          data = await ReversePayment(payload)
            .then((res) => {
              successResponse(res);
              GetAvailableSalesAndBalance();
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.REQUEST_CARD:
          dispatch(setLoading("pending"));
          data = await RequestCorporateCard(payload)
            .then((res) => {
              const responsePayload = res?.Payload || res?.payload || res || {};
              const isPhysicalCardRequest =
                Number(payload?.CardProductTypeId) === 1;
              const isDisposableCardRequest =
                Number(payload?.CardProductTypeId) === 2;
              const isSuccessfulCardRequest =
                Number(responsePayload?._status) === 200 ||
                Number(responsePayload?.flagCode) === 0;
              const hasCardStatusMarker =
                responsePayload?._status !== undefined ||
                responsePayload?.flagCode !== undefined;
              const responseIsPopup = Boolean(
                res?.isPopup || responsePayload?.isPopup,
              );

              if (
                isPhysicalCardRequest &&
                isSuccessfulCardRequest &&
                typeof window !== "undefined"
              ) {
                window.dispatchEvent(
                  new CustomEvent("new:corporate-card-request-success", {
                    detail: {
                      requestPayload: payload,
                      response: res,
                    },
                  })
                );
                return;
              }

              if (isDisposableCardRequest && responseIsPopup) {
                successResponse(res);
                return;
              }

              if (
                isDisposableCardRequest &&
                hasCardStatusMarker &&
                !isSuccessfulCardRequest
              ) {
                successResponse(res);
                return;
              }

              if (
                isDisposableCardRequest &&
                typeof window !== "undefined"
              ) {
                window.dispatchEvent(
                  new CustomEvent("new:corporate-card-request-success", {
                    detail: {
                      requestPayload: payload,
                      response: res,
                    },
                  })
                );
                return;
              }

              successResponse(res);
            })
            .catch((error) => {
              if (
                Number(payload?.CardProductTypeId) === 2 &&
                typeof window !== "undefined"
              ) {
                window.dispatchEvent(
                  new CustomEvent("new:corporate-card-request-failed", {
                    detail: {
                      requestPayload: payload,
                      error,
                    },
                  })
                );
              }
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.EDIT_CARD:
          dispatch(setLoading("pending"));
          data = await EditCorporateCard(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        // case ACTION_TYPES.EDIT_USER_PAYROLL_ADVANCE:
        //     dispatch(setLoading("pending"));
        //     data = await EditUserPayrollAdvance(payload)
        //         .then((res) => {
        //             successResponse(res.Payload);
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         }).finally(() => dispatch(setPayrollPageActiveButton({ name: "Quick Pay" })));
        //     break;
        case ACTION_TYPES.EXECUTE_COMPANY_TRANSFER:
          dispatch(setLoading("pending"));
          data = await ExecuteCompanyTransfer(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(
                setBobCorporateActiveButton({ name: "Payment Overview" }),
              );
              dispatch(resetBobCorporateState());
              dispatch(resetState());
            });
          break;
        case ACTION_TYPES.EXECUTE_INTERNATIONAL_TRANSFER:
          dispatch(setLoading("pending"));
          data = await ExecuteInternationalTransfer(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setSelectedActionButton({ name: "Transfers" }));
            })
            .catch((error) => {
              errorResponse(error);
              dispatch(setSelectedActionButton({ name: "Transfers" }));
            });
          break;
        case ACTION_TYPES.SAVE_CORPORATE_TVA_DATA:
          dispatch(setLoading("pending"));
          data = await saveCorporateTvaData(payload)
            .then((res) => {
              const responsePayload = res?.Payload || res;

              if (responsePayload?.isPopup) {
                const normalizedFlag = Number(responsePayload?.flagCode);
                dispatch(setIsPopup(true));
                dispatch(setFlag(responsePayload?.flagCode ?? 10));
                dispatch(
                  setResponseTitle(responsePayload?.Title || "VAT Payment"),
                );
                dispatch(
                  setResponseDescription(
                    responsePayload?.Message ||
                      "VAT payment response received.",
                  ),
                );
                dispatch(
                  setResponseInfo({
                    vatPayment: true,
                    redirectToVatOverview: normalizedFlag === 0,
                    forceWarningIcon: normalizedFlag === 1,
                  }),
                );
                return responsePayload;
              }

              successResponse(
                responsePayload || {
                  isPopup: true,
                  flagCode: 0,
                  Title: "VAT Payment",
                  Message: "VAT payment request completed.",
                },
              );
              dispatch(
                setResponseInfo({
                  vatPayment: true,
                  redirectToVatOverview: true,
                }),
              );
              return responsePayload;
            })
            .catch((error) => {
              const responseData =
                error?.response?.data?.Payload || error?.response?.data;

              if (
                responseData?.isPopup ||
                responseData?.Title ||
                responseData?.Message
              ) {
                const normalizedFlag = Number(responseData?.flagCode);
                dispatch(setLoading("idle"));
                dispatch(setIsPopup(true));
                dispatch(setFlag(responseData?.flagCode ?? 10));
                dispatch(
                  setResponseTitle(
                    responseData?.Title ||
                      responseData?.PopupTitle ||
                      "VAT Payment Failed",
                  ),
                );
                dispatch(
                  setResponseDescription(
                    responseData?.Message ||
                      responseData?.PopupDescription ||
                      "Unable to complete VAT payment right now.",
                  ),
                );
                dispatch(
                  setResponseInfo({
                    vatPayment: true,
                    redirectToVatOverview: false,
                    forceWarningIcon: normalizedFlag === 1,
                  }),
                );
                return;
              }

              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.ACTIVATE_DEACTIVATE_CARD:
          dispatch(setLoading("pending"));
          data = await ActivateDeactivateCorporateCard(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.CANCEL_CARD:
          dispatch(setLoading("pending"));
          data = await CancelCorporateCard(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        // case ACTION_TYPES.CONFIRM_EMPLOYEE:
        //     dispatch(setLoading("pending"));
        //     data = await ConfirmEligibleEmployees(payload)
        //         .then((res) => {
        //             successResponse(res);
        //             dispatch(setIsFromPayrollPage(false));
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         })
        //     break;

        case ACTION_TYPES.SUBMIT_PAYROLL:
          dispatch(setLoading("pending"));
          data = await SubmitPayrollTemplate(payload)
            .then((res) => {
              if ([0, 1].includes(res?.flagCode)) {
                navigate("/payroll/payrollsummary");
                dispatch(
                  setResponseInfo({ payroll: true, payrollSummary: res }),
                );
                dispatch(setPayrollCount(res.PayrollSummary.TotalEmployees));
              }
              errorCaseInSuccessResponse(res);
              dispatch(setLoading("idle"));
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.UPLOAD_BASE_SALARY:
          dispatch(setLoading("pending"));
          try {
            const res = await UploadQuickPay(payload);

            if (res) {
              dispatch(
                setResponseInfo({ quickpay: true, quickpaySummary: res }),
              );
              dispatch(setUploadNewBaseSalaryData(res?.Payload));
              dispatch(
                setQuickPayPageActiveButton({ name: "QuickPaySummary" }),
              );
            } else {
              errorCaseInSuccessResponse(res);
            }
            dispatch(setLoading("idle"));
          } catch (error) {
            errorResponse(error);
            dispatch(setLoading("idle"));
          }
          break;
        case ACTION_TYPES.PUSH_QUICK_PAY:
          dispatch(setLoading("pending"));
          try {
            const res = await PushQuickPay(payload);
            if (res) {
              successResponse(res);
              const status = await GetQuickPayDesign();
              localStorage.setItem("data", true);

              dispatch(setQuickPayPageActiveButton({ name: "QuickPay" }));
            }
            dispatch(setLoading("idle"));
          } catch (error) {
            errorResponse(error);
            dispatch(setLoading("idle"));
          }
          break;
        case ACTION_TYPES.DELETE_SINGLE_USER_QUICK_PAY:
          dispatch(setLoading("pending"));
          await DeleteSingleUserQuickPay(payload)
            .then((res) => {
              successResponse(res);
              GetQuickPayDetails(pageDetails?.identifier, pageDetails?.status);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.EDIT_SINGLE_USER_QUICK_PAY:
          dispatch(setLoading("pending"));
          await EditSingleUserQuickPay(payload)
            .then((res) => {
              successResponse(res);
              GetQuickPayDetails(pageDetails?.identifier, pageDetails?.status);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        // case ACTION_TYPES.REPLACE_PAYROLL_ADVANCE_LIST:
        //     dispatch(setLoading("pending"));
        //     data = ReplacePayrollAdvanceList(payload)
        //         .then((res) => {
        //             dispatch(setResponseInfo(null));
        //             dispatch(setIsReplaceBaseSalary(true));

        //             // TODO: UPDATE List and data
        //             dispatch(setUploadNewBaseSalaryData(res.Payload.payrollAdvanceDetailsList))
        //             dispatch(setUploadNewBaseSalaryStatistics(res.Payload.payrollAdvanceListStatistics))

        //             dispatch(setLoading("idle"));
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         }).finally(() => dispatch(setPayrollPageActiveButton({ name: "Quick Pay" })));
        //     break;
        case ACTION_TYPES.APPROVE_QUICK_PAY:
          dispatch(setLoading("pending"));
          data = ApproveRejectQuickPay(payload)
            .then((res) => {
              dispatch(setResponseInfo(null));
              dispatch(setShowQuickPayDetails(false));
              dispatch(setCheckerAdvanceId(0));
              dispatch(setQuickPayCheckerAdvanceId(0));
              dispatch(setQuickPayList([]));
              dispatch(setLoading("idle"));
              successResponse(res);
            })
            .catch((error) => {
              dispatch(setLoading("idle"));
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.APPROVE_QUICK_PAY_MOBILE:
          dispatch(setLoading("pending"));
          data = ApproveRejectQuickPayMobile(payload)
            .then((res) => {
              dispatch(setResponseInfo(null));
              dispatch(setShowQuickPayDetails(false));
              dispatch(setCheckerAdvanceId(0));
              dispatch(setQuickPayCheckerAdvanceId(0));
              dispatch(setQuickPayList([]));
              dispatch(setLoading("idle"));
              successResponse(res);
            })
            .catch((error) => {
              dispatch(setLoading("idle"));
              errorResponse(error);
            });
          break;
        // case ACTION_TYPES.PUSH_PAYROLL_ADVANCE_LIST:
        //     dispatch(setLoading("pending"));
        //     data = PushPayrollAdvanceList(payload)
        //         .then((res) => {
        //             dispatch(setResponseInfo(null));
        //             dispatch(setContinueToConfirm(false));
        //             dispatch(setIsConfirmationPopupOpen(false));
        //             dispatch(setIsReplaceBaseSalary(false));
        //             dispatch(setIsUpdatingCashAdvance(false));
        //             GetCashAdvanceDesign();
        //             successResponse(res.Payload);
        //             dispatch(setLoading("idle"));
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         }).finally(() => dispatch(setPayrollPageActiveButton({ name: "Quick Pay" })));
        //     break;
        case ACTION_TYPES.PUSH_QUICK_PAY:
          dispatch(setLoading("pending"));
          data = await PushQuickPay(payload)
            .then((res) => {
              dispatch(setResponseInfo(null));
              successResponse(res);
              dispatch(setLoading("idle"));
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() =>
              dispatch(setQuickPayPageActiveButton({ name: "Quick Pay" })),
            );
          break;
        case ACTION_TYPES.CONFIRM_PAYROLL:
          dispatch(setLoading("pending"));
          data = await ConfirmPayrollTemplate(payload)
            .then((res) => {
              successResponse(res);
              dispatch(setResponseInfo(null));
              // if (res.Reference) {
              //     CommunicatePayroll(res.Reference);
              // }
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.PAY_SINGLE_PAYROLL:
          dispatch(setLoading("pending"));
          data = await PaySinglePayroll(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.CANCEL_REQUEST_TO_PAY:
          dispatch(setLoading("pending"));
          data = await CancelRequestToPay(payload)
            .then((res) => {
              successResponse(res);
              GetPaymentRequest(selectedPage);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.DELETE_PAYROLL:
          dispatch(setLoading("pending"));
          data = await DeletePayroll(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.DELETE_PAYROLL_MOBILE:
          dispatch(setLoading("pending"));
          data = await DeletePayrollMobile(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;

        case ACTION_TYPES.REJECT_PAYROLL:
          dispatch(setLoading("pending"));
          data = await RejectPayroll(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.REJECT_PAYROLL_MOBILE:
          dispatch(setLoading("pending"));
          data = await RejectPayrollMobile(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.APPROVE_PAYROLL:
          dispatch(setLoading("pending"));
          data = await ApprovePayroll(payload)
            .then((res) => {
              successResponse(res);
              if (res.SendNotif) {
                // CommunicatePayroll(payload.Reference, payload.PayrollIds);
              }
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.APPROVE_PAYROLL_MOBILE:
          dispatch(setLoading("pending"));
          data = await ApprovePayrollMobile(payload)
            .then((res) => {
              successResponse(res);
              if (res.SendNotif) {
                // CommunicatePayroll(payload.Reference, payload.PayrollIds);
              }
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.NEW_CASHOUT_ORDER:
          dispatch(setLoading("pending"));
          data = await NewCashoutOrder(payload)
            .then((res) => {
              successResponse(res);
              if ([5, 6].includes(res?.GlobalCode)) {
                dispatch(
                  setResponseInfo({
                    GlobalCode: res.GlobalCode,
                    ReceiverName: res?.ReceiverName || res?.Name,
                    Code: res?.Code,
                    Amount: res?.Amount,
                    CashoutType: res?.CashoutType,
                    QRCode: res?.QRCode,
                    Address: res?.Address,
                    Method: "cashout",
                  }),
                ).finally(() => dispatch(setLoading("idle")));
                dispatch(setResponseTitle("Cash Out Request Successful"));
              }
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.NEW_CASHIN_ORDER:
          dispatch(setLoading("pending"));
          data = await NewCashDepositRequest(payload)
            .then((res) => {
              successResponse(res);
              if (res?.GlobalCode === 6) {
                dispatch(
                  setResponseInfo({
                    GlobalCode: 6,
                    ReceiverName: res?.Name,
                    QRCode: res?.QRCode,
                    Amount: res?.Amount,
                    Address: res?.Address,
                    Method: "cashin",
                  }),
                );
              } else if (res?.GlobalCode === 5) {
                dispatch(
                  setResponseInfo({
                    GlobalCode: res?.GlobalCode,
                    ReceiverName: res?.Name,
                    Code: res?.Code,
                    Amount: res?.Amount,
                    CashoutType: res?.CashoutType,
                    QRCode: res?.QRCode,
                    Method: "cashin",
                    phone: res?.Phone,
                    Address: res?.Address,
                    SendSms: res?.SendSms,
                  }),
                );
              } else {
                dispatch(
                  setResponseInfo({
                    GlobalCode: 3,
                  }),
                );
              }
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.NEW_BUTLER_REQUEST:
          dispatch(setLoading("pending"));
          data = await NewButlerRequest(payload)
            .then((res) => {
              successResponse(res);
              const payloadData = res;
              if (!payloadData) {
                dispatch(setResponseInfo({ GlobalCode: 3 }));
                return;
              }
              if (res?.flagCode === 0) {
              dispatch(
                setResponseInfo({
                  GlobalCode: 7,
                  Amount: payloadData?.Amount,
                  Fees: payloadData?.Fees,
                  PaymentReference: payloadData?.PaymentReference,
                  FileName: payloadData?.FileName,
                  FileUrl: payloadData?.FileUrl,
                  PersonInCharge: payloadData?.PersonInChange,
                  MobileNo: payloadData?.MobileNo,
                  Email: payloadData?.Email,
                  DateTime: payloadData?.DateTime,
                  Address: payloadData?.DeliveryLocation,
                  QRCode: payloadData?.QrCode,
                  DeliveryService: payloadData?.DeliveryService,
                  Method: "cashin",
                  PaymentTo: payloadData?.PaymentTo,
                  Title: payloadData?.Title,
                }),
              );
            }
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(setLoading("idle"));
              dispatch(setButlerTabs("Orders"));
            });
          break;
        case ACTION_TYPES.CREATE_NEW_ROLE:
          dispatch(setLoading("pending"));
          data = await InsertProfile(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;

        case ACTION_TYPES.PAY_ALFA_PREPAID:
          dispatch(setLoading("pending"));
          data = await BuyAlfaCard(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.PAY_ALFA_POSDPAID:
          dispatch(setLoading("pending"));
          data = await PayAlfaBill(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.PAY_TOUCH_POSTPAID:
          dispatch(setLoading("pending"));
          data = await PayTouchBill(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.PAY_TOUCH_PREPAID:
          dispatch(setLoading("pending"));
          data = await BuyTouchCard(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.PAY_OGERO_PREPAID:
          dispatch(setLoading("pending"));
          data = await PayOgeroBill(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.PAY_TERRANET_LANDLINE:
          dispatch(setLoading("pending"));
          data = await PayTerranetBill(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;

        case ACTION_TYPES.REFILL_SODETEL:
          dispatch(setLoading("pending"));
          data = await sodetelRefill(payload)
            .then((res) => {
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.DOWNLOAD_SOA_PDF:
          dispatch(setLoading("pending"));
          try {
            const res = await DownloadCorporateSoa(payload);

            if (res?.BlobUrl) {
              const link = document.createElement("a");
              link.href = res.BlobUrl;
              link.download = "StatementOfAccount.pdf";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }

            successResponse(res);
          } catch (error) {
            errorResponse(error);
          } finally {
            await GetAccountBalance("2024-08-01", "2024-09-01");
            dispatch(setLoading("idle"));
          }
          break;
        case ACTION_TYPES.PURCHASE_ESIM:
          dispatch(setLoading("pending"));
          data = await PurchaseTopupEsim(payload)
            .then((res) => {
              sessionStorage.setItem("esimId", res.data?.plan?.id);
              successResponse(res?.data?.Popup);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;

        case ACTION_TYPES.EXPORT_PAYROLL_RECEIPTS:
          data = ExportPayrollReceipts(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.CANCEL_PAYROLL:
          data = CancelPayrollTemplate(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.ACTION_EMPLOYEES_OVERVIEW:
          dispatch(setLoading("pending"));
          data = ActionEmployeesOverview(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));
          break;
        case ACTION_TYPES.GENERATE_REPORT:
          dispatch(setLoading("pending"));
          data = await newReport(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => dispatch(setLoading("idle")));

          break;
        case ACTION_TYPES.DELETE_REPORT:
          dispatch(setLoading("pending"));
          data = await deleteReport(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;

        case ACTION_TYPES.RESEND_REPORT:
          dispatch(setLoading("pending"));
          data = await resendReport(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;

        case ACTION_TYPES.UPDATE_REPORT:
          dispatch(setLoading("pending"));
          data = await updateReport(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.DELETE_PENDING_APPROVAL_QUICK_PAY:
          dispatch(setLoading("pending"));
          data = await deletePendingApprovalQuickPay(payload)
            .then((res) => {
              successResponse(res);
              GetQuickPayList();
              CreateQuickPayRequest();
            })
            .catch((error) => {
              errorResponse(error);
            })
            .finally(() => {
              dispatch(setQuickPayPageActiveButton({ name: "QuickPay" }));
              dispatch(setLoading("idle"));
            });
          break;
        case ACTION_TYPES.DELETE_ACTIVE_QUICK_PAY:
          dispatch(setLoading("pending"));
          data = await deleteApprovalQuickPay(payload)
            .then((res) => {
              successResponse(res);
              GetQuickPayList();
              CreateQuickPayRequest();
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.CREATE_QUICK_PAY_REQUEST:
          dispatch(setLoading("pending"));
          data = await CreateQuickPayRequest(payload)
            .then((res) => {
              successResponse(res);
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.UPDATE_AUTOMATIC_BILL_PAYMENT:
          dispatch(setLoading("pending"));
          try {
            data = await UpdateAutomaticBillPayment(payload)
              .then((res) => {
                successResponse(res);
              })
              .catch((error) => {
                errorResponse(error);
              });
          } finally {
            // if (info && autoPaystatus !== null) {
            //   try {
            //     await OgeroAutoPay(info, autoPaystatus);

            //   } catch (error) {
            //     console.error("Error calling OgeroAutoPay:", error);
            //   }
            // }
            dispatch(setLoading("idle"));
          }
          break;
        case ACTION_TYPES.UPLOAD_NEW_QUICK_PAY_EMPLOYEES:
          dispatch(setLoading("pending"));
          data = await UploadNewQuickPayEmployees(payload)
            .then((res) => {
              successResponse(res.Payload);
              dispatch(setLoading("idle"));
              if (res && [0, 1].includes(res?.Payload?.flagCode)) {
                dispatch(setUploadNewBaseSalaryData(res.Payload));
                dispatch(setNewPushQuickPayStatus(false));
                dispatch(
                  setQuickPayPageActiveButton({ name: "QuickPaySummary" }),
                );
              }
            })
            .catch((error) => {
              dispatch(setLoading("idle"));
              errorResponse(error);
            });
          break;
        case ACTION_TYPES.PUSH_NEW_QUICK_PAY_EMPLOYEES:
          dispatch(setLoading("pending"));
          try {
            const res = await PushNewQuickPayEmployees(payload);
            if (res) {
              successResponse(res);
              const status = await GetQuickPayDesign();
              localStorage.setItem("data", true);
              dispatch(setQuickPayPageActiveButton({ name: "QuickPay" }));
            }
            dispatch(setLoading("idle"));
          } catch (error) {
            errorResponse(error);
            dispatch(setLoading("idle"));
          }
          break;
        case ACTION_TYPES.UPDATE_EMPLOYEE_LOAN_ELIGILIBILITY:
          dispatch(setLoading("pending"));
          data = await UpdateEmployeeLoanEligibility(payload)
            .then((res) => {
              successResponse(res);
              GetEmployeeLoanEligiblity();
            })
            .catch((error) => {
              errorResponse(error);
            });
          break;
        // case ACTION_TYPES.DISABLE_ALL_PAYROLL_ADVANCE:
        //     dispatch(setLoading("pending"));
        //     data = await DisableAllPayrollAdvance(payload)
        //         .then((res) => {
        //             successResponse(res);
        //             dispatch(setResponseInfo(null));
        //         })
        //         .catch((error) => {
        //             errorResponse(error);
        //         });
        //     break;

        default:
          break;
      }

      return data;
    };

    if (
      error ||
      qrTimeout ||
      (status &&
        status.length > 0 &&
        (status === "AUTHORIZED" ||
          status === "EXPIRED" ||
          status === "CLOSED" ||
          status === "USED"))
    ) {
      if (status === "AUTHORIZED") {
        window.dispatchEvent(
          new CustomEvent("new:authorization-authorized", {
            detail: {
              actionPayload,
              actionType,
              authorizationCode,
            },
          }),
        );
        const baseRequest = new BaseRequest(
          sessionStorage.getItem("SessionID"),
        );
        const payload = {
          ...baseRequest,
          ...actionPayload,
          AuthorizationCode: authorizationCode,
        };
        check(actionType, payload);
        dispatch(setOpLoading("pending"));
      }
      onCloseQrReset();
      clearInterval(timer.current);
      return;
    }
  }, [status, actionType, actionPayload]);
}
